import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=e3792b84&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=e3792b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3792b84",
  null
  
)

export default component.exports